export default function CuentaDetail({ cuenta }) {
  if (!cuenta) {
    return (
      <div className="rounded-2xl border border-dashed border-[rgb(var(--border))] bg-[rgba(var(--panel),0.4)] p-6 text-center text-sm text-muted">
        Seleccioná una cuenta para ver el detalle.
      </div>
    );
  }

  return (
    <section className="rounded-2xl border border-[rgb(var(--border))] bg-[rgba(var(--panel),0.9)] p-6 shadow-[0_20px_40px_-24px_rgba(var(--shadow),0.4)]">
      <header className="flex flex-col gap-1">
        <span className="text-xs uppercase tracking-wider text-[rgb(var(--muted))]">Cuenta contable</span>
        <h2 className="text-xl font-semibold text-[rgb(var(--fg))]">
          {cuenta.codigo} · {cuenta.nombre}
        </h2>
        <p className="text-sm text-[rgb(var(--muted))]">Nivel {cuenta.nivel} · {cuenta.tipo}</p>
      </header>

      <dl className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-2">
        <DetailItem label="Tipo" value={translateTipo(cuenta.tipo)} />
        <DetailItem label="Moneda" value={cuenta.moneda} />
        <DetailItem label="Imputable" value={cuenta.imputable ? 'Sí' : 'No'} />
        <DetailItem label="Activa" value={cuenta.activo ? 'Sí' : 'No'} />
        <DetailItem label="Cuenta Padre" value={cuenta.padreLabel ?? 'Sin asignar'} />
        <DetailItem label="Creada" value={formatDateTime(cuenta.createdAt)} />
        <DetailItem label="Actualizada" value={formatDateTime(cuenta.updatedAt)} />
      </dl>
    </section>
  );
}

function DetailItem({ label, value }) {
  return (
    <div className="rounded-xl border border-[rgb(var(--border))] bg-[rgba(var(--subpanel),0.65)] px-4 py-3">
      <dt className="text-xs uppercase tracking-wide text-[rgb(var(--muted))]">{label}</dt>
      <dd className="mt-1 text-sm font-medium text-[rgb(var(--fg))]">{value}</dd>
    </div>
  );
}

function translateTipo(tipo) {
  switch (tipo) {
    case 'A':
      return 'Activo';
    case 'P':
      return 'Pasivo';
    case 'PN':
      return 'Patrimonio Neto';
    case 'I':
      return 'Ingresos';
    case 'G':
      return 'Gastos';
    default:
      return tipo;
  }
}

function formatDateTime(value) {
  if (!value) return '-';
  try {
    const date = new Date(value);
    return `${date.toLocaleDateString()} ${date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
  } catch (error) {
    return value;
  }
}
